import { useEffect, useState } from "react";
import api from "../../services/api";
import "./CreditsPurchase.css";
import { useNavigate } from "react-router-dom";
import {
  POST_ORDER_REPORTS,
  POST_ORDER_CREDITS,
  TOKEN,
  GET_ALL_SAVED_CARD_DETAILS,
  SECRET_KEY,
  IV_KEY,
  BASEURL,
  CUSTOMERID,
  POST_PAYPAL_PAYMENT,
  GetToken,
} from "../../CONSTANTS";
import CryptoJS from "crypto-js";
import { Container, Row, Spinner, Col, Form, Button } from "react-bootstrap";
import { Loader } from "../../Components/Loader";
import Cookies from "js-cookie";
import { useAuth } from "../../context/AuthContext";
import { use } from "react";
import { useScreenSize, useCustomScreen } from "../../Components/Utils";
import toast from "react-hot-toast";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import NumberInputComponent from './NumberInputComponent';
export default function CreditsPurchase() {
  const [creditSummary, setCreditSummary] = useState([]);
  const [reports, setReports] = useState([]);
  const navigate = useNavigate();
  const [selBrickToBuy, setSelBrickToBuy] = useState({
    brickName: "",
    price: 0,
    brickCount: 0, 
  });
  const [buyCreditItems, setBuyCreditItems] = useState([
    {
      type: "BASIC",
      count: 0,
      price: 0,
    },
    {
      type: "STANDARD",
      count: 0,
      price: 0,
    },
    {
      type: "CLAIMS",
      count: 0,
      price: 0,
    },
    {
      type: "COMPREHENSIVE",
      count: 0,
      price: 0,
    },
  ]);
  const [summaryOptions, setSummaryOptions] = useState([
    {
      type: "BASIC",
      count: 0,
      price: 0,
    },
    {
      type: "Standard",
      count: 0,
      value: 0,
    },
    {
      type: "Claims",
      count: 0,
      value: 0,
    },
    {
      type: "COMPREHENSIVE",
      count: 0,
      value: 0,
    },
  ]);

  const [discount, setDiscount] = useState(0);
  const [creditsTotal, setCreditsTotal] = useState(0);
  const [invalidExpiry, setInValidExpiry] = useState(false);
  const [selectedCard, setSelectedCard] = useState("");

  const [brickPromo, setBrickPromo] = useState("");
  const [brickDiscountNotFlag, setBrickDiscountNotFlag] = useState(false);
  const [brickDiscountPerc, setBrickDiscountPerc] = useState(0);
  const [brickDiscount, setBrickDiscount] = useState(0);
  const [showBrickPromoErrorMsg, setShowBrickPromoErrorMsg] = useState(false);
  const [highestBrickCostProduct, setHighestBrickCostProduct] = useState({});
  const [secHighestBrickCost, setSecHighestBrickCost] = useState({});
  const [thirdHighestBrickCost, setThirdHighestBrickCost] = useState({});
  const [leastBrickCost, setLeastBrickCost] = useState({});
  const [secBrickCostProduct, setSecBrickCoseProduct] = useState({});

  const [discountPerc, setDiscountPerc] = useState(0);
  const [paidTransactionId, setPaidTransactionId] = useState(0);
  const [showCredits, setShowCredits] = useState(false);
  const [quantity, setQuantity] = useState("");
  const [allCards, setAllCards] = useState([]);
  const [cardName, setCardName] = useState("");
  const [defaultCardNumber, setDefaultCardNumber] = useState("");

  const { authToken, decodedToken } = useAuth();
  const [token, setToken] = useState(null);
  const [saveAndAddRadio, setSaveAndAddRadio] = useState("savedCard");
  const [cardExpirationDetails, setCardExpirationDetails] = useState("");
  const [isCardDefault, setIsCardDefault] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [makeDefaultCard, setMakeDefaultCard] = useState(false);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();

  const tokenFromCookies = Cookies.get("token");
  const customerIdFromCookies = JSON.parse(
    Cookies.get("decodedToken")
  ).customerid;
  const customerId =
    window.localStorage.getItem("customerId") || customerIdFromCookies;
  const TOKEN = window.localStorage.getItem("token") || tokenFromCookies;

  useEffect(() => {
    const storedToken =
      tokenFromCookies || localStorage.getItem("token") || authToken;
    setToken(storedToken);
  }, []);

  // const TOKEN =
  //   tokenFromCookies || window.localStorage.getItem("token") || authToken;
  const [inputData, setInputData] = useState(1);
  const [productId, setProductId] = useState(0);
  const quantityOfBrics = parseInt(inputData) * 10;

  const [cardsLoading, setCardsLoading] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const EstimatedTotal =
    summaryOptions.reduce((accum, item) => accum + item.value, 0) -
    discount -
    creditsTotal;
  const EstimateBrickTotal = inputData
    ? buyCreditItems.reduce((accum, item) => accum + item.price, 0) -
      brickDiscount
    : 0;
  const [loading, setLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [error, setError] = useState("");
  const [cardType, setCardType] = useState("");

  useEffect(() => {
    onCreditCheckHandler();
    onReportsHandler();
  }, []);

  useEffect(() => {
    savedCards();
  }, [customerId, token]);

  const encryptKey = (data) => {
    const encrypted = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV_KEY),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return encrypted.toString();
  };

  const savedCards = async () => {
    try {
      setCardsLoading(!cardsLoading);
      const response = await fetch(
        `${GET_ALL_SAVED_CARD_DETAILS}/${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        }
      );
      if (response.ok) {
        const result = await response.json();
        let tempRes = result["paymentCards"];
        setCustomerName(result.fullName);
        tempRes.map((r, rInx) => {
          if ("isDefault" in r) {
            if (r["isDefault"]) {
              "paymentCardId" in r && setSelectedCard(r);
              "cardNumber" in r && setDefaultCardNumber(r["cardNumber"]);
            }
          }
        });
        setAllCards([...result["paymentCards"]]);
      } else {
        console.error("Failed to fetch data");
      }
    } catch (e) {
      console.log("error loading cards!", e);
    } finally {
      setCardsLoading(false);
    }
  };

  const decryptKey = (encrptedData) => {
    const decrypted = CryptoJS.AES.decrypt(
      encrptedData,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(IV_KEY),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  };

  const placeOrderFromSavedCard = async () => {
    if (EstimateBrickTotal > 0) {
      let tempPaymentDetails = {
        customerId: `${customerId}`,
        expMonth: "",
        expYear: "",
        cardName: "",
        cardNumber: "",
        amount: 0,
        saveCard: false,
        makeDefaultCard: false,
        vaultId: "",
        paypalCustomerId: "",
      };
      tempPaymentDetails.amount = EstimateBrickTotal;
      tempPaymentDetails.cardName = customerName;
      let expDetails = selectedCard?.cardExpiry
        ? selectedCard?.cardExpiry?.split("-")
        : [];
      tempPaymentDetails.expMonth = expDetails.length > 1 ? expDetails[1] : "";
      tempPaymentDetails.expYear = expDetails.length > 0 ? expDetails[0] : "";
      tempPaymentDetails.cardNumber = selectedCard?.cardNumber;
      tempPaymentDetails.vaultId = selectedCard?.vaultId;
      tempPaymentDetails.paypalCustomerId = selectedCard?.paypalCustomerId;
      let temp = {
        paypalRequest: "",
      };
      temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));
      try {
        setLoading(!loading);
        let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
          method: "POST",
          body: JSON.stringify(temp),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        });
        if (result.ok) {
          const res = await result.json();
          // if ('isSuccess' in res && 'paymentStatus' in res && res?.paymentStatus === 'COMPLETED') {
          setPaidTransactionId(res?.transactionId);
          const info = {
            customerId: Number(customerId),
            productId: productId,
            brickPrice: EstimateBrickTotal,
            brickQuantity: quantityOfBrics,
            refundPrice: 0,
            isAutorenew: "No",
            paymentParams: "",
            refundParams: "",
            discount: brickDiscount,
            promotionCode: brickPromo,
            paymentType: "Charge",
            cardLastDigits: res?.metadata?.cardLastDigits,
            paymentTransactionId: res?.transactionId,
          };

          //   info.productId = selBrickToBuy?.productId
          const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
            method: "POST",
            body: JSON.stringify(info),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${TOKEN}`, // Add your token here
            },
          });

          if (brickRes.ok) {
            toast.success("Credits Purchase Successful", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            setBrickPromo("");
            setBrickDiscount(0);
            setShowCredits(false);
            setIsPromoApplied(false);
            onReportsHandler();
            onCreditCheckHandler();
          } else {
            toast.error("Credits Purchase Failed..!", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
          // }
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        }
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }
        console.log(e);
      } finally {
        setLoading(false);
      }
    } else if (brickPromo && EstimateBrickTotal <= 0) {
      const info = {
        customerId: Number(customerId),
        productId: productId,
        brickPrice: EstimateBrickTotal,
        brickQuantity: quantityOfBrics,
        refundPrice: 0,
        isAutorenew: "No",
        paymentParams: "",
        refundParams: "",
        discount: brickDiscount,
        promotionCode: brickPromo,
        paymentType: "Promo",
        cardLastDigits: null,
        paymentTransactionId: null,
      };

      try {
        setLoading(!loading);

        const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
          method: "POST",
          body: JSON.stringify(info),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        });

        if (brickRes.ok) {
          toast.success("Credits Purchase Successful", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  color: "green",
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleCheck}
              />
            ),
            style: {
              backgroundColor: "#E7EFC7",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          setBrickPromo("");
          setBrickDiscount(0);
          setShowCredits(false);
          setIsPromoApplied(false);
          onReportsHandler();
          onCreditCheckHandler();
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        } else {
          toast.error("Credits Purchase Failed..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    } else if (EstimateBrickTotal < 0) return;
  };

  const placeOrderFromNewCard = async () => {
    const cardNum = cardNumber.replace(/\s/g, "");
    const [expMonth, expYear] = cardExpirationDetails.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;

    if (allCards.length >= 5 && saveCard) {
      toast.error("Cannot Add more than 5 cards", {
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
        },
      });
      return;
    }
    if (EstimateBrickTotal > 0) {
      let tempPaymentDetails = {
        customerId: `${customerId}`,
        expMonth: `${expMonth}`,
        expYear: `${expiry}`,
        cardName: `${cardName}`,
        cardNumber: `${cardNum}`,
        amount: 0,
        saveCard: `${saveCard}`,
        makeDefaultCard: `${makeDefaultCard}`,
        vaultId: "",
        paypalCustomerId: "",
      };
      tempPaymentDetails.amount = EstimateBrickTotal;

      let temp = {
        paypalRequest: "",
      };

      temp.paypalRequest = encryptKey(JSON.stringify(tempPaymentDetails));

      try {
        setLoading(!loading);

        let result = await fetch(`${POST_PAYPAL_PAYMENT}`, {
          method: "POST",
          body: JSON.stringify(temp),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        });

        if (result.ok) {
          const res = await result.json();

          // if ('isSuccess' in res && 'paymentStatus' in res && res?.paymentStatus === 'COMPLETED') {
          setPaidTransactionId(res?.transactionId);
          const info = {
            customerId: Number(customerId),
            productId: productId,
            brickPrice: EstimateBrickTotal,
            brickQuantity: quantityOfBrics,
            refundPrice: 0,
            isAutorenew: "No",
            paymentParams: "",
            refundParams: "",
            discount: brickDiscount,
            promotionCode: brickPromo,
            paymentType: "Charge",
            cardLastDigits: res?.metadata?.cardLastDigits,
            paymentTransactionId: res?.transactionId,
          };

          const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
            method: "POST",
            body: JSON.stringify(info),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${TOKEN}`, // Add your token here
            },
          });

          if (brickRes.ok) {
            toast.success("Credits Purchase Successful", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    color: "green",
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                  }}
                  icon={faCircleCheck}
                />
              ),
              style: {
                backgroundColor: "#E7EFC7",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
            setBrickPromo("");
            setBrickDiscount(0);
            setShowCredits(false);
            setIsPromoApplied(false);
            setCardName("");
            setCardNumber("");
            setCardExpirationDetails("");
            setMakeDefaultCard(false);
            setSaveCard(false);
            onReportsHandler();
            onCreditCheckHandler();
            savedCards();
          } else {
            toast.error("Credits Purchase Failed..!", {
              duration: 6000,
              icon: (
                <FontAwesomeIcon
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.15rem"
                      : isXlScreen
                      ? "1rem"
                      : isIpadProPortrait
                      ? "1.8rem"
                      : isLargeScreen
                      ? "1rem"
                      : isMediumScreen
                      ? "1.1rem"
                      : "1rem",
                  }}
                  icon={faCircleExclamation}
                />
              ),
              style: {
                backgroundColor: "#FFC1B4",
                color: "red",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.15rem"
                  : isXlScreen
                  ? "1rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "1rem"
                  : isMediumScreen
                  ? "1.1rem"
                  : "1rem",
                marginTop: is4kScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "2rem"
                  : "",
              },
            });
          }
          // }
          setInputData(0);
          setSelBrickToBuy({});
          setBuyCreditItems((prev) =>
            prev.map((item) => ({ ...item, count: 0, price: 0 }))
          );
        }
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }
        console.log(e);
      } finally {
        setLoading(false);
      }
    } else if (brickPromo && EstimateBrickTotal <= 0) {
      try {
        setLoading(!loading);

        const info = {
          customerId: Number(customerId),
          productId: productId,
          brickPrice: EstimateBrickTotal,
          brickQuantity: quantityOfBrics,
          refundPrice: 0,
          isAutorenew: "No",
          paymentParams: "",
          refundParams: "",
          discount: brickDiscount,
          promotionCode: brickPromo,
          paymentType: "Promo",
          cardLastDigits: null,
          paymentTransactionId: null,
        };
        //   info.productId = selBrickToBuy?.productId
        const brickRes = await fetch(`${POST_ORDER_CREDITS}`, {
          method: "POST",
          body: JSON.stringify(info),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`, // Add your token here
          },
        });

        if (brickRes.ok) {
          toast.success("Credits Purchase Successful", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  color: "green",
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleCheck}
              />
            ),
            style: {
              backgroundColor: "#E7EFC7",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
          setBrickPromo("");
          setBrickDiscount(0);
          setShowCredits(false);
          setIsPromoApplied(false);
          setCardName("");
          setCardNumber("");
          setCardExpirationDetails("");
          setMakeDefaultCard(false);
          setSaveCard(false);
          onReportsHandler();
          onCreditCheckHandler();
        } else {
          toast.error("Credits Purchase Failed..!", {
            duration: 6000,
            icon: (
              <FontAwesomeIcon
                style={{
                  fontSize: is4kScreen
                    ? "1.9rem"
                    : isXxlScreen
                    ? "1.15rem"
                    : isXlScreen
                    ? "1rem"
                    : isIpadProPortrait
                    ? "1.8rem"
                    : isLargeScreen
                    ? "1rem"
                    : isMediumScreen
                    ? "1.1rem"
                    : "1rem",
                }}
                icon={faCircleExclamation}
              />
            ),
            style: {
              backgroundColor: "#FFC1B4",
              color: "red",
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.15rem"
                : isXlScreen
                ? "1rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "1rem"
                : isMediumScreen
                ? "1.1rem"
                : "1rem",
              marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
            },
          });
        }
        // }
        setInputData(0);
        setSelBrickToBuy({});
        setBuyCreditItems((prev) =>
          prev.map((item) => ({ ...item, count: 0, price: 0 }))
        );
      } catch (e) {
        if (e?.status === 401) {
          navigate("/login");
        }
        console.log(e);
      } finally {
        setLoading(false);
      }
    }
  };

  const [discountMetaData, setDiscountMetaData] = useState(null);
  const [showDiscountError, setShowDiscountError] = useState(false);
  const [isPromoApplied, setIsPromoApplied] = useState(false);

  const checkBrickPromo = async () => {
    const url = `${BASEURL}promocodes/promocode-validation`;

    const payloadData = {
      code: brickPromo,
      customerId: customerId,
      appliesOnBrick: true,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${GetToken()}`,
      },
      body: JSON.stringify(payloadData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw response;
      })
      .then((data) => {
        setBrickDiscountNotFlag(false);
        setDiscountMetaData(data);
        if (typeof data === "object") {
          if ("isValid" in data && data["isValid"]) {
            setShowBrickPromoErrorMsg(false);
            if ("discountType" in data && data["discountType"] === "P") {
              if (
                "promoCodeFor" in data &&
                data["promoCodeFor"] === "AccountCredits"
              ) {
                if (
                  "appliesOn" in data &&
                  data["appliesOn"] === "singleReport"
                ) {
                  setBrickDiscountPerc(data["discount"]);
                  sumaryCalAfterBrickDiscount(
                    data["reportType"],
                    data["discount"]
                  );
                } else if (
                  "appliesOn" in data &&
                  data["appliesOn"] === "entire"
                ) {
                  setDiscountPerc(data["discount"]);
                  sumaryCalEntireAfterBrickDiscount(data["reportType"]);
                }
              }
            } else if ("discountType" in data && data["discountType"] === "F") {
              if (
                "promoCodeFor" in data &&
                data["promoCodeFor"] === "AccountCredits"
              ) {
                if ("appliesOn" in data && data.appliesOn === "entire") {
                  setDiscount(data.discount);
                } else if (
                  "appliesOn" in data &&
                  data.appliesOn === "singleReport"
                ) {
                  if (data.reportType) {
                    if (data.reportType === "any") {
                      let basicCredits = buyCreditItems.find(
                        (item) => item.type.toUpperCase() === "BASIC"
                      );
                      let standardCredits = buyCreditItems.find(
                        (item) => item.type.toUpperCase() === "STANDARD"
                      );
                      let comprehensiveCredits = buyCreditItems.find(
                        (item) => item.type.toUpperCase() === "COMPREHENSIVE"
                      );
                      let claimsCredits = buyCreditItems.find(
                        (item) => item.type.toUpperCase() === "CLAIMS"
                      );

                      if (basicCredits.count > 0) {
                        let baseValue = basicCredits.price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setIsPromoApplied(true);
                        setShowDiscountError(false);
                      } else if (standardCredits.count > 0) {
                        let baseValue = standardCredits.price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setIsPromoApplied(true);
                        setShowDiscountError(false);
                      } else if (comprehensiveCredits.count > 0) {
                        let baseValue = comprehensiveCredits.price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setIsPromoApplied(true);
                        setShowDiscountError(false);
                      } else if (claimsCredits.count > 0) {
                        let baseValue = claimsCredits.price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setIsPromoApplied(true);
                        setShowDiscountError(false);
                      } else {
                        setBrickDiscount(0);
                        setIsPromoApplied(false);
                        setShowDiscountError(true);
                        setShowBrickPromoErrorMsg(true);
                      }
                    } else if (data.reportType.toUpperCase() === "BASIC") {
                      if (buyCreditItems[0].count > 0) {
                        let baseValue = buyCreditItems[0].price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setIsPromoApplied(true);
                        setShowDiscountError(false);
                      } else {
                        setBrickDiscount(0);
                        setIsPromoApplied(false);
                        setShowDiscountError(true);
                      }
                    } else if (data.reportType.toUpperCase() === "STANDARD") {
                      if (buyCreditItems[1].count > 0) {
                        let baseValue = buyCreditItems[1].price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setShowDiscountError(false);
                        setIsPromoApplied(true);
                      } else {
                        setBrickDiscount(0);
                        setShowDiscountError(true);
                        setIsPromoApplied(false);
                      }
                    } else if (
                      data.reportType.toUpperCase() === "COMPREHENSIVE"
                    ) {
                      if (buyCreditItems[3].count > 0) {
                        let baseValue = buyCreditItems[3].price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setShowDiscountError(false);
                        setIsPromoApplied(true);
                      } else {
                        setBrickDiscount(0);
                        setShowDiscountError(true);
                        setIsPromoApplied(false);
                      }
                    } else if (data.reportType.toUpperCase() === "CLAIMS") {
                      if (buyCreditItems[2].count > 0) {
                        let baseValue = buyCreditItems[2].price;
                        let capedValue =
                          data.discount > baseValue ? baseValue : data.discount;
                        setBrickDiscount(capedValue);
                        setShowDiscountError(false);
                        setIsPromoApplied(true);
                      } else {
                        setBrickDiscount(0);
                        setShowDiscountError(true);
                        setIsPromoApplied(false);
                      }
                    }
                  }
                }
              }
            }
          } else {
            setShowBrickPromoErrorMsg(true);
          }
        }
      });
  };

  const sumaryCalAfterBrickDiscount = (reportType, discountPercentage) => {
    if (reportType === "any") {
      let basicCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "BASIC"
      );
      let standardCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "STANDARD"
      );
      let comprehensiveCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "COMPREHENSIVE"
      );
      let claimsCredits = buyCreditItems.find(
        (item) => item.type.toUpperCase() === "CLAIMS"
      );

      if (basicCredits.count > 0) {
        setBrickDiscount((basicCredits.price * discountPercentage) / 100);
        setIsPromoApplied(true);
        setShowDiscountError(false);
      } else if (standardCredits.count > 0) {
        setBrickDiscount((standardCredits.price * discountPercentage) / 100);
        setIsPromoApplied(true);
        setShowDiscountError(false);
      } else if (comprehensiveCredits.count > 0) {
        setBrickDiscount(
          (comprehensiveCredits.price * discountPercentage) / 100
        );
        setIsPromoApplied(true);
        setShowDiscountError(false);
      } else if (claimsCredits.count > 0) {
        setBrickDiscount((claimsCredits.price * discountPercentage) / 100);
        setIsPromoApplied(true);
        setShowDiscountError(false);
      } else {
        setBrickDiscount(0);
        setIsPromoApplied(false);
        setShowDiscountError(true);
        setShowBrickPromoErrorMsg(true);
      }

      // if (
      //   reportType.toUpperCase() === "BASIC" ||
      //   reportType.toUpperCase() === "STANDARD" ||
      //   reportType.toUpperCase() === "COMPREHENSIVE" ||
      //   reportType.toUpperCase() === "CLAIMS"
      // ) {
      //   let tempS = buyCreditItems.filter((s) => {
      //     if (
      //       s.count > 0 &&
      //       s.type.toUpperCase() === reportType.toUpperCase()
      //     ) {
      //       setBrickDiscount((s.price * discountPercentage) / 100);
      //       setIsPromoApplied(true);
      //       setShowDiscountError(false);
      //       return s;
      //     } else {
      //       setIsPromoApplied(false);
      //       setShowDiscountError(true);
      //     }
      //   });
      //   if (!tempS.length) {
      //     setBrickDiscountNotFlag(true);
      //     setBrickDiscount(0);
      //   }
      // }
    } else if (reportType.toUpperCase() === "BASIC") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "BASIC") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
      } else if (!tempS.length) {
        // setDiscountNotFlag(true);
        setShowDiscountError(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "STANDARD") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "STANDARD") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
      } else if (!tempS.length) {
        setShowDiscountError(true);
        // setShowBrickPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else if (reportType.toUpperCase() === "COMPREHENSIVE") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "COMPREHENSIVE") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
      } else if (!tempS.length) {
        setShowDiscountError(true);
        setDiscount(0);
        setIsPromoApplied(false);
        // setShowBrickPromoErrorMsg(true);
      }
    } else if (reportType.toUpperCase() === "CLAIMS") {
      let tempS = buyCreditItems.filter((s) => {
        if (s.count > 0 && s.type.toUpperCase() === "CLAIMS") {
          setBrickDiscount((s.price * discountPercentage) / 100);
          setIsPromoApplied(true);
          return s;
        }
      });
      if (tempS.length > 0) {
        setIsPromoApplied(true);
      } else if (!tempS.length) {
        setShowDiscountError(true);
        // setShowBrickPromoErrorMsg(true);
        setDiscount(0);
        setIsPromoApplied(false);
      }
    } else {
      setBrickDiscount(0);
      setIsPromoApplied(false);
      setShowDiscountError(true);
    }
  };

  const sumaryCalEntireAfterBrickDiscount = (dis) => {
    if (dis === "any") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type !== "RUSH") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);

      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "basic") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "BASIC") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);

      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "standard") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "Standard") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);

      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "comprehensive") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "Comprehensive") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);

      setBrickDiscount((temp * brickDiscountPerc) / 100);
    } else if (dis.toLowerCase() === "claims") {
      let temp = buyCreditItems.reduce((accum, item) => {
        if (item.type === "Claims") {
          return accum + item.price;
        } else {
          return accum;
        }
      }, 0);

      setBrickDiscount((temp * brickDiscountPerc) / 100);
    }
  };

  const onBrickPromoHandler = (e) => {
    if (!e.target.value) {
      setIsPromoApplied(false);
      setShowDiscountError(false);
      setShowBrickPromoErrorMsg(false);
      setBrickDiscount(0);
    }
    let tempB = brickPromo;
    tempB = e.target.value;
    setBrickPromo(tempB);
  };

  const [selectedProduct, setSelectedProduct] = useState(null);

  const brickSelectionHandler = (credit) => {
    setShowDiscountError(false);
    setIsPromoApplied(false);
    setShowBrickPromoErrorMsg(false);
    setProductId(credit.productId);
    setSelectedProduct(credit);
    setInputData(1); // Reset quantity to 1

    let temp = { ...selBrickToBuy };
    temp.brickName = credit.name;
    temp.price = credit.brickPrice;
    temp.brickCount = credit.brickQuantity;
    // setSelBrickToBuy({ ...temp });
    setSelBrickToBuy({
      brickName: credit.name,
      price: credit.brickPrice,
      brickCount: credit.brickQuantity,
    });
    setBrickPromo("");
    setBrickDiscount(0);
    // Call the correct count handler with initial quantity 1
    switch (credit.name) {
      case "BASIC":
        basicCountHandler(1);
        break;
      case "STANDARD":
        standardCountHandler(1);
        break;
      case "CLAIMS":
        claimCountHandler(1);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(1);
        break;
    }
  };

  async function onReportsHandler() {
    try {
      setLoading(!loading);
      let result = await api({
        method: "GET",
        url: "/products",
      });

      const filteredReports = result.filter((item) => item.name !== "EXPANDED");
      setReports(filteredReports);
      const tempFilteredReports = [...filteredReports]; //shallow copy
      // const tempFilteredReports = filteredReports.map((report) => ({
      //   ...report,
      // })); //deep copy
      // const tempFilteredReports = structuredClone(filteredReports);

      const sortedByHighestPrice = tempFilteredReports.sort(
        (a, b) => b.price - a.price
      );

      const firstHighestPrice = sortedByHighestPrice[0];
      const secondHighestPrice = sortedByHighestPrice[1];
      const thirdHighestPrice = sortedByHighestPrice[2];
      const leastPrice = sortedByHighestPrice.at(-1);

      setHighestBrickCostProduct(firstHighestPrice);
      setSecHighestBrickCost(secondHighestPrice);
      setThirdHighestBrickCost(thirdHighestPrice);
      setLeastBrickCost(leastPrice);
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  }

  async function onCreditCheckHandler() {
    try {
      let result = await api({
        method: "GET",
        // url: `/customers/${CUSTOMERID}/ytd-report-balance`,
        // url: `/customers/getcustomer-details-with-report-balance/${CUSTOMERID}`,
        url: `customerbricks/GetAvailableCredits/${customerId}`,
      });

      if (result) {
        const filteredReports = result.filter(
          (item) => item.productName !== "EXPANDED"
        );
        setCreditSummary(filteredReports);
      }
    } catch (e) {
      console.log(e);
      navigate("/login");
    }
  }

  const basicCountHandler = (value) => {
    // Clone current credit items
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    const resReport = reports.find((option) => option?.name === "BASIC");
    const brickPrice = resReport?.brickPrice || 0;

    cred.forEach((c) => {
      if (c.type === "BASIC") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });
    setBuyCreditItems([...cred]);
  };

  const standardCountHandler = (value) => {
    // Clone current credit items
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find((option) => option?.name === "STANDARD");
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "STANDARD") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });

    setBuyCreditItems([...cred]);
  };

  const claimCountHandler = (value) => {
    // Clone current credit items
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find((option) => option?.name === "CLAIMS");
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "CLAIMS") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });

    setBuyCreditItems([...cred]);
  };

  const comprehensiveCountHandler = (value) => {
    // Clone current credit items
    const cred = [...buyCreditItems];

    // If value is empty, reset everything to 0
    if (!value || isNaN(value)) {
      cred.forEach((c) => {
        c.count = 0;
        c.price = 0;
      });
      setBuyCreditItems([...cred]);
      return;
    }

    // Reset all count and price before applying new changes
    cred.forEach((c) => {
      c.count = 0;
      c.price = 0;
    });

    // Get price for STANDARD type
    const resReport = reports.find(
      (option) => option?.name === "COMPREHENSIVE"
    );
    const brickPrice = resReport?.brickPrice || 0;

    // Update only STANDARD type
    cred.forEach((c) => {
      if (c.type === "COMPREHENSIVE") {
        c.count = Number(value) * 10;
        c.price = Number(value) * brickPrice;
      }
    });

    setBuyCreditItems([...cred]);
  };

  const handleIncrement = () => {
    if (!selBrickToBuy?.brickName) return; // Ensure a brick is selected
    const newValue = Number(inputData) + 1;
    setInputData(newValue);

    switch (selBrickToBuy.brickName) {
      case "BASIC":
        basicCountHandler(newValue);
        break;
      case "STANDARD":
        standardCountHandler(newValue);
        break;
      case "CLAIMS":
        claimCountHandler(newValue);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(newValue);
        break;
    }
  };

  const handleDecrement = () => {
    if (!selBrickToBuy?.brickName || inputData <= 1) return; // Prevent decrementing below zero
    const newValue = inputData - 1;
    setInputData(newValue);

    switch (selBrickToBuy.brickName) {
      case "BASIC":
        basicCountHandler(newValue);
        break;
      case "STANDARD":
        standardCountHandler(newValue);
        break;
      case "CLAIMS":
        claimCountHandler(newValue);
        break;
      case "COMPREHENSIVE":
        comprehensiveCountHandler(newValue);
        break;
    }
  };

  const changeCardNameHandler = (e) => {
    setCardName(e.target.value);
  };
  const changeCardExpirationDetails = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    if (value.length > 2) {
      value = value.substring(0, 2) + "/" + value.substring(2, 4);
    }

    // Validate expiry date
    if (value.length === 5) {
      // MM/YY format has 5 characters including the slash
      const [month, year] = value.split("/").map(Number);

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // JS months are 0-based
      const currentYear = currentDate.getFullYear() % 100; // Get last 2 digits of year

      if (
        year < currentYear ||
        (year === currentYear && month < currentMonth) ||
        month < 1 ||
        month > 12
      ) {
        setInValidExpiry(true);
      } else {
        setInValidExpiry(false);
      }
    } else {
      setInValidExpiry(false);
    }

    setCardExpirationDetails(value);
  };

  const handleBackspace = (e) => {
    if (e.key === "Backspace" && cardExpirationDetails.length <= 3) {
      setCardExpirationDetails("");
    }
  };

  const saveCardHandler = async () => {
    if (!cardName || !cardNumber || !cardExpirationDetails) return;
    const [expMonth, expYear] = cardExpirationDetails.split("/");
    const yearPrefix = new Date().getFullYear();
    const stringfiedYearPrefix = yearPrefix.toString().slice(0, 2);
    const expiry = stringfiedYearPrefix + expYear;
    const tempCardNumber = cardNumber
      ? String(cardNumber).replaceAll(" ", "")
      : "";
    let res = {
      customerId: `${CUSTOMERID}`,
      expMonth: `${expMonth}`,
      expYear: `${expiry}`,
      cardName: `${cardName}`,
      cardNumber: `${tempCardNumber}`,
      paypalCustomerId: "",
    };
    try {
      setLoading(true);
      const response = await fetch(`${BASEURL}paymentcards/add-card`, {
        method: "POST",
        body: JSON.stringify(res),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
        },
      });
      if (response) {
        savedCards();
        clearFields();
      }
    } catch (e) {
      if (e?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
    // handleCardPopupClose();
  };

  const handleChange = (event) => {
    let input = event.target.value;

    // Remove non-digit characters
    input = input.replace(/\D/g, "");

    // Limit the card number to 16-19 digits
    if (input.length > 19) {
      input = input.slice(0, 19);
    }

    // Format the card number (e.g., 1234 5678 9012 3456)
    const formattedInput = input.match(/.{1,4}/g)?.join(" ") || input;

    setCardNumber(formattedInput);

    // Identify card type
    const detectedCardType = getCardType(input);
    setCardType(detectedCardType);

    // Validate using Luhn algorithm
    if (input.length < 16) {
      const isValid = isValidCardNumber(input);
      setError(isValid ? "" : "Invalid card number");
    } else {
      setError("");
    }
  };

  const getCardType = (cardNumber) => {
    const patterns = {
      visa: /^4[0-9]{0,}$/, // Visa starts with 4
      mastercard: /^(5[1-5]|2[2-7])/, // Mastercard starts with 51-55 or 22-27
      amex: /^3[47]/, // American Express starts with 34 or 37
      discover: /^6(?:011|5[0-9]{2})/, // Discover starts with 6011, 65
    };

    for (const [cardType, pattern] of Object.entries(patterns)) {
      if (pattern.test(cardNumber)) {
        return cardType;
      }
    }
    return "unknown";
  };

  const isValidCardNumber = (cardNumber) => {
    const digits = cardNumber.replace(/\D/g, ""); // Remove non-digit characters
    let sum = 0;
    let shouldDouble = false;

    // Loop through the digits from right to left
    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = parseInt(digits[i], 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }

    return sum % 10 === 0;
  };

  const clearFields = () => {
    setCardName("");
    setCardNumber("");
    setCardType("");
    setIsCardDefault(false);
    setCardExpirationDetails("");
  };
  const [changeCardLoading, setChanegCardLoading] = useState(false);
  const changePrimaryCard = async (e, selIndex) => {
    let tempAllCards = allCards.length > 0 ? [...allCards] : [];
    if (tempAllCards.length && tempAllCards.length >= selIndex) {
      let selCard = tempAllCards[selIndex];
      selCard["isDefault"] = true;
      setSelectedCard(selCard);
      try {
        setChanegCardLoading(!changeCardLoading);
        const response = await fetch(
          `${BASEURL}paymentcards/${CUSTOMERID}/true/${selCard.paymentCardId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${TOKEN}`, // Add your TOKEN here
            },
          }
        );

        tempAllCards[selIndex] = selCard;
        if (response) {
          savedCards();
        }
      } catch (err) {
        console.log(err);
      } finally {
        setChanegCardLoading(false);
      }
    }
    setAllCards([...tempAllCards]);
  };

  // const [makeDefault, setMakeDefault] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingDefault, setLoadingDefault] = useState(false);
  const [message, setMessage] = useState("");

  const handleChoosePaymentType = () => {
    if (saveAndAddRadio === "savedCard") {
      placeOrderFromSavedCard();
    } else if (saveAndAddRadio === "addCard") {
      placeOrderFromNewCard();
    }
  };

  const [showAddOrRemoveCardPopup, setShowAddOrRemoveCardPopup] =
    useState(false);
  const handleCardPopupClose = () => {
    setCardName("");
    setCardNumber("");
    setCardExpirationDetails("");
    setIsCardDefault(false);
    setShowAddOrRemoveCardPopup(false);
  };

  const deleteSavedCard = async (selCard) => {
    // http://apiqa.rooftopmeasurements.com/paymentcards/delete-card/{PaymentCardId}/{VaultId}
    const response = await fetch(
      `${BASEURL}paymentcards/delete-card/${selCard?.paymentCardId}/${selCard?.vaultId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add your token here
        },
      }
    );
    if (response) {
      handleCardPopupClose();
    }
  };

  return (
    <>
      {loading ? (
        <Container
          style={{ height: "100vh" }}
          className="w-100% d-flex justify-content-center align-items-center"
        >
          <Spinner animation="border" role="status"></Spinner>
        </Container>
      ) : (
        <div
          className=""
          style={{
            height: "auto",
            overflowY: "scroll",
            width: "100%",
          }}
        >
          <h5
            style={{
              background: "lightblue",
              padding: "1em",
              fontSize: is4kScreen
                ? "2rem"
                : isXxlScreen
                ? "1.4rem"
                : isXlScreen
                ? "1.2rem"
                : isIpadProPortrait
                ? "1.95rem"
                : isLargeScreen
                ? ""
                : isMediumScreen
                ? "1.7rem"
                : "",
            }}
          >
            <b>Credit Balance</b>
          </h5>
          <Container className="">
            <Row>
              <Col
                sm={12}
                md={12}
                lg={isIpadProPortrait ? 12 : 7}
                className={
                  isSmallScreen
                    ? "border-0"
                    : isMediumScreen
                    ? "border-0"
                    : isIpadProPortrait
                    ? "border-0"
                    : "apply-border-left"
                }
                style={{
                  borderLeft: isSmallScreen ? "2px solid black" : "none",
                }}
              >
                <br></br>

                <div className="row">
                  {creditSummary.length &&
                    creditSummary.map((c, i) => (
                      <>
                        {/* <div className='col-md-2'>{c['reportsPurchased']}</div>
                                <div className='col-md-1'>{c['reportsOrdered']}</div> */}
                        <div
                          className="col-sm-6 col-6 col-md-6 "
                          style={{ textAlign: "center" }}
                        >
                          <Row>
                            <Col md={12}>
                              <p
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.9rem"
                                    : isXxlScreen
                                    ? ""
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isLargeScreen
                                    ? ""
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "14px",
                                }}
                              >
                                {`${c.productName}`}
                                {isSmallScreen ? (
                                  <>
                                    <br /> CREDITS
                                  </>
                                ) : isMediumScreen ? (
                                  <>
                                    <br /> CREDITS
                                  </>
                                ) : isIpadProPortrait ? (
                                  <>
                                    <br /> CREDITS
                                  </>
                                ) : (
                                  " CREDITS"
                                )}
                                :
                              </p>
                            </Col>
                            <Col md={12}>
                              <p
                                style={{
                                  fontSize: is4kScreen
                                    ? "2rem"
                                    : isXxlScreen
                                    ? ""
                                    : isXlScreen
                                    ? ""
                                    : isIpadProPortrait
                                    ? "1.7rem"
                                    : isLargeScreen
                                    ? ""
                                    : isMediumScreen
                                    ? "1.3rem"
                                    : "16px",
                                }}
                              >
                                <strong>{c.overAllRemaining}</strong>
                              </p>{" "}
                            </Col>
                          </Row>
                        </div>
                      </>
                    ))}
                </div>
                <br></br>
                <div>
                  <h6
                    style={{
                      textAlign: "center",
                      fontSize: is4kScreen
                        ? "2rem"
                        : isXxlScreen
                        ? ""
                        : isXlScreen
                        ? ""
                        : isIpadProPortrait
                        ? "1.6rem"
                        : isLargeScreen
                        ? ""
                        : isMediumScreen
                        ? "1.3rem"
                        : "15px",
                    }}
                  >
                    BUY MORE CREDITS
                  </h6>

                  <div className="row mt-2 gx-0">
                    {" "}
                    {reports.length > 0 &&
                      reports.map((credit, index) => (
                        <div
                          key={index}
                          className="col-sm-6 col-6 col-md-6 d-flex justify-content-center"
                        >
                          <div
                            className={`w-100 p-1 ${
                              selBrickToBuy?.brickName?.trim().toUpperCase() ===
                              credit?.name?.trim().toUpperCase()
                                ? "selected"
                                : "not-selected"
                            }`}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              border: "1px solid #e1dfdf",
                              borderRadius: "5px",
                              minWidth: "3em",
                              margin: "1em",
                            }}
                            onClick={() => {
                              brickSelectionHandler(credit);
                            }}
                            role="button"
                            tabIndex={0}
                          >
                            <p
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? ""
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.8rem"
                                  : isMediumScreen
                                  ? "1.3rem"
                                  : "14px",
                                marginBottom: "0px",
                                fontWeight: "bold",
                              }}
                            >
                              <b>{credit.name}</b>
                            </p>
                            <p
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? ""
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? " 1.3rem"
                                  : "14px",
                                marginBottom: "0px",
                              }}
                            >
                              {credit.brickQuantity} CREDITS
                            </p>
                            <p
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? ""
                                  : isXlScreen
                                  ? ""
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.3rem"
                                  : "14px",
                                color:
                                  selBrickToBuy?.brickName?.toUpperCase() ===
                                  credit?.name?.toUpperCase()
                                    ? "#ffffff"
                                    : "#000",
                                fontWeight: "bold",
                              }}
                            >
                              ${credit.brickPrice} USD
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>

                  <br></br>

                  <div
                    className="d-flex flex-wrap justify-content-center align-items-center gap-3 pb-4"
                    style={{ width: "100%" }}
                  >
                    {/* Promo Title */}
                    <div className="col-5 col-sm-4 col-md-3 text-center">
                      <b
                        style={{
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? ""
                            : isXlScreen
                            ? ""
                            : isIpadProPortrait
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.2rem"
                            : "14px",
                        }}
                      >
                        Add Promo Code
                      </b>
                    </div>

                    {/* Promo Input */}
                    <div className="col-5 credits-purchase col-sm-4 col-md-4">
                      <input
                        type="text"
                        value={brickPromo}
                        onChange={onBrickPromoHandler}
                        className="form-control w-100"
                        style={{
                          height: isIpadProPortrait ? "3rem" : "",
                          fontSize: isIpadProPortrait
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.2rem "
                            : "",
                        }}
                      />
                    </div>

                    {/* Apply Button */}
                    <div className="col-4 col-sm-4 col-md-3 text-center">
                      <button
                        type="submit"
                        className="topbar-btns search-btn  w-100"
                        style={{
                          // border: "1px solid black",
                          fontSize: is4kScreen
                            ? "2rem"
                            : isIpadProPortrait
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.2rem"
                            : "",
                        }}
                        disabled={brickPromo === ""}
                        onClick={checkBrickPromo}
                      >
                        Apply
                      </button>
                    </div>
                    <div className="text-center">
                      {isPromoApplied && (
                        <span
                          style={{
                            color: "green",
                            fontSize: is4kScreen
                              ? "1.8rem"
                              : isXxlScreen
                              ? ""
                              : isXlScreen
                              ? ""
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "14px",
                          }}
                          className="d-block mt-1"
                        >
                          Promo code applied successfully!
                        </span>
                      )}
                      {showDiscountError && (
                        <span
                          style={{
                            color: "red",
                            fontSize: is4kScreen
                              ? "1.8rem"
                              : isXxlScreen
                              ? ""
                              : isXlScreen
                              ? ""
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "14px",
                          }}
                          className="d-block mt-1"
                        >
                          Please enter a valid promo code
                        </span>
                      )}
                      {showBrickPromoErrorMsg && (
                        <span
                          style={{
                            color: "red",
                            fontSize: is4kScreen
                              ? "1.8rem"
                              : isXxlScreen
                              ? ""
                              : isXlScreen
                              ? ""
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "14px",
                          }}
                          className="d-block mt-1"
                        >
                          Please enter a valid Promo Code.
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="d-flex flex-row justify-content-evenly align-items-center gap-2 w-100">
                    <div className="d-flex flex-row justify-content-center align-items-center gap-2 pb-4">
                      <div className="">
                        <input
                          name="payementMethodRadio"
                          value="savedCard"
                          checked={saveAndAddRadio === "savedCard"}
                          onChange={(e) => setSaveAndAddRadio(e.target.value)}
                          type="radio"
                          style={{
                            width: is4kScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "1.4rem"
                              : "",
                            height: is4kScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "1.4rem"
                              : "",
                          }}
                        />
                      </div>
                      <div className="d-flex m-0 flex-column justify-content-center align-items-center ">
                        <h6
                          style={{
                            fontSize: is4kScreen
                              ? "1.6rem"
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "14px",
                          }}
                        >
                          Pay with Card: {defaultCardNumber || "N/A"}
                        </h6>
                      </div>
                    </div>
                    <div className="d-flex flex-row justify-content-center align-items-center gap-2 pb-4">
                      <div>
                        <input
                          name="paymentMethodRadio"
                          value="addCard"
                          checked={saveAndAddRadio === "addCard"}
                          onChange={(e) => setSaveAndAddRadio(e.target.value)}
                          // disabled={}
                          type="radio"
                          style={{
                            width: is4kScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "1.4rem"
                              : "",
                            height: is4kScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "1.4rem"
                              : "",
                          }}
                        />
                      </div>
                      <div>
                        <h6
                          style={{
                            fontSize: is4kScreen
                              ? "1.6rem"
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "14px",
                          }}
                        >
                          Add New Card
                        </h6>
                      </div>
                    </div>
                  </div>

                  {saveAndAddRadio === "savedCard" && (
                    <>
                      {cardsLoading ? (
                        <Container className="w-100%  d-flex justify-content-center align-items-center">
                          <Spinner animation="border" role="status"></Spinner>
                        </Container>
                      ) : (
                        <Container fluid>
                          {/* Header Row */}
                          <Row className=" d-none d-sm-flex text-center">
                            <Col sm={4} className=" text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? "1.1rem"
                                    : "14px",
                                }}
                              >
                                Make Default
                              </strong>
                            </Col>
                            <Col sm={4} className="text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? "1.1rem"
                                    : "14px",
                                }}
                              >
                                Card Number
                              </strong>
                            </Col>
                            <Col sm={4} className="text-center">
                              <strong
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.6rem"
                                    : isIpadProPortrait
                                    ? "1.5rem"
                                    : isMediumScreen
                                    ? "1.1rem"
                                    : "14px",
                                }}
                              >
                                Expiration Date
                              </strong>
                            </Col>
                          </Row>
                          {!allCards.length && (
                            <p className="text-center">No Cards Found</p>
                          )}
                          {/* Cards Data */}
                          {allCards.length > 0 &&
                            allCards.map((card, cInx) => (
                              <Row
                                key={cInx}
                                className="border-bottom py-2 align-items-center"
                              >
                                {/* Is Primary */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="d-flex align-items-center gap-1 justify-content-sm-evenly mb-2 mb-sm-0"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.6rem"
                                        : isIpadProPortrait
                                        ? "1.3rem"
                                        : isMediumScreen
                                        ? "1.1rem"
                                        : "14px",
                                    }}
                                  >
                                    Make Default
                                  </strong>
                                  <input
                                    className="m-sm-2"
                                    type="radio"
                                    value={card?.isDefault}
                                    style={{
                                      width: is4kScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.5rem"
                                        : "",
                                      height: is4kScreen
                                        ? "1.5rem"
                                        : isIpadProPortrait
                                        ? "1.5rem"
                                        : "",
                                    }}
                                    checked={
                                      card?.paymentCardId ===
                                      selectedCard.paymentCardId
                                    }
                                    onChange={(e) => changePrimaryCard(e, cInx)}
                                  />
                                </Col>
                                {/* Card Number */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="mb-1 mb-sm-0 text-start text-md-center"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{
                                      fontSize: is4kScreen ? "1.6rem" : "14px",
                                    }}
                                  >
                                    Card Number:
                                  </strong>{" "}
                                  <strong
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.6rem"
                                        : isIpadProPortrait
                                        ? "1.5rem"
                                        : isMediumScreen
                                        ? "1.1rem"
                                        : "14px",
                                    }}
                                  >
                                    {card?.cardNumber}
                                  </strong>
                                </Col>

                                {/* Expiration Date */}
                                <Col
                                  xs={12}
                                  sm={4}
                                  className="mb-2 mb-sm-0 text-start text-md-center"
                                >
                                  <strong
                                    className="d-sm-none"
                                    style={{
                                      fontSize: is4kScreen ? "1.6rem" : "14px",
                                    }}
                                  >
                                    Expiration Date:
                                  </strong>{" "}
                                  <strong
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.6rem"
                                        : isIpadProPortrait
                                        ? "1.5rem"
                                        : isMediumScreen
                                        ? "1.1rem"
                                        : "14px",
                                    }}
                                  >
                                    {card?.cardExpiry}
                                  </strong>
                                </Col>

                                {/* Delete Option */}
                                {/* <Col
                                                           xs={12}
                                                           sm={2}
                                                           className="text-danger text-sm-end"
                                                         >
                                                           <span
                                                             style={{
                                                               textDecoration: "underline",
                                                               cursor: "pointer",
                                                             }}
                                                             onClick={() => deleteSavedCard(card)}
                                                           >
                                                             Delete
                                                           </span>
                                                         </Col> */}
                              </Row>
                            ))}
                        </Container>
                      )}
                    </>
                  )}

                  {saveAndAddRadio === "addCard" && (
                    <div className="credits-purchase">
                      <Form style={{ padding: "0px 2em" }}>
                        <Form.Group
                          className="mb-1 row align-items-center"
                          controlId="cardName"
                        >
                          <Form.Label
                            className="col-md-5 col-12 mb-2 mb-md-0 text-start"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : "",
                            }}
                          >
                            Card Name:
                          </Form.Label>

                          <div
                            className={`col-md-${
                              isIpadProPortrait
                                ? "7"
                                : isMediumScreen
                                ? "7"
                                : "5"
                            } col-12`}
                          >
                            <Form.Control
                              style={{
                                height: isIpadProPortrait ? "3rem" : "",
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                              className="col-md-7"
                              placeholder="Card Name"
                              value={cardName}
                              onChange={(e) => changeCardNameHandler(e)}
                              type="text"
                            />
                          </div>
                        </Form.Group>

                        <Form.Group
                          className="mb-1 row align-items-center"
                          controlId="cardNumber"
                        >
                          <Form.Label
                            className="col-md-5 col-12 mb-2 mb-md-0 text-start"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : "",
                            }}
                          >
                            Card Number:
                          </Form.Label>

                          <div
                            className={`col-md-${
                              isIpadProPortrait
                                ? "7"
                                : isMediumScreen
                                ? "7"
                                : "5"
                            } col-12`}
                          >
                            <input
                              style={{
                                height: isIpadProPortrait ? "3rem" : "",
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                              type="text"
                              className="col-md-5 form-control"
                              id="cardNumber"
                              value={cardNumber}
                              onChange={handleChange}
                              placeholder="1234 5678 9012 3456"
                              maxLength="19"
                            />
                          </div>
                          {error && (
                            <p
                              style={{
                                color: "red",
                                textAlign: "center",
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : "",
                              }}
                            >
                              {error}
                            </p>
                          )}
                        </Form.Group>

                        {cardNumber && cardType ? (
                          <Form.Group
                            className="mb-3 row align-items-center"
                            controlId="expiryDate"
                          >
                            <Form.Label
                              className="col-md-5 col-12 mb-2 mb-md-0 text-start"
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : "",
                              }}
                            >
                              Card Type:
                            </Form.Label>

                            <div className="col-md-5 col-12 ">
                              <Form.Label
                                style={{
                                  fontSize: is4kScreen
                                    ? "1.8rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : isIpadProPortrait
                                    ? "1.6rem"
                                    : "",
                                }}
                              >
                                {cardType.toUpperCase()}
                              </Form.Label>
                            </div>
                          </Form.Group>
                        ) : (
                          ""
                        )}

                        <Form.Group
                          className="mb-3 row align-items-center"
                          controlId="expiryDate"
                        >
                          <Form.Label
                            className="col-md-5 col-12 mb-2 mb-md-0 text-start"
                            style={{
                              fontSize: is4kScreen
                                ? "1.8rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : "",
                            }}
                          >
                            Expiration Month/Year:
                          </Form.Label>

                          <div
                            className={`col-md-${
                              isIpadProPortrait
                                ? "7"
                                : isMediumScreen
                                ? "7"
                                : "5"
                            } col-12`}
                          >
                            <Form.Control
                              style={{
                                height: isIpadProPortrait ? "3rem" : "",
                                fontSize: isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : "",
                              }}
                              placeholder="MM/YY"
                              type="text"
                              value={cardExpirationDetails}
                              onChange={(e) => changeCardExpirationDetails(e)}
                              onKeyDown={handleBackspace}
                              maxLength={7}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group
                          className="mb-3 row align-items-center w-100 "
                          controlId="expiryDate"
                        >
                          <Form.Label className="col-md-5  col-12 mb-2 mb-md-0 text-center"></Form.Label>

                          <div className="col-md-5  w-full col-12">
                            <div>
                              {invalidExpiry ? (
                                <>
                                  <p
                                    className="text-danger"
                                    style={{
                                      fontSize: is4kScreen
                                        ? "1.8rem"
                                        : isMediumScreen
                                        ? "1.2rem"
                                        : isIpadProPortrait
                                        ? "1.6rem"
                                        : "",
                                    }}
                                  >
                                    Invalid Expiry details
                                  </p>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </Form.Group>
                      </Form>

                      <Row>
                        <Col className="d-flex justify-content-center align-items-center gap-3">
                          <Form.Group controlId="saveCard" className="mb-3">
                            <Form.Check
                              type="checkbox"
                              label={"Save this card"}
                              checked={saveCard}
                              onChange={(e) => setSaveCard(e.target.checked)}
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : "",
                              }}
                            />
                          </Form.Group>

                          <Form.Group controlId="makeDefault" className="mb-3">
                            <Form.Check
                              type="checkbox"
                              label={"Make default card"}
                              checked={makeDefaultCard}
                              onChange={(e) =>
                                setMakeDefaultCard(e.target.checked)
                              }
                              disabled={!saveCard || loadingDefault}
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isMediumScreen
                                  ? "1.2rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : "",
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <br></br>
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={isIpadProPortrait ? 12 : 5}
                className=" pt-xs-4 p-2 d-flex  flex-column   "
              >
                <h6
                  style={{
                    marginLeft: "25px",
                    textAlign: "center", 
                    fontSize: is4kScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : "",
                  }}
                >
                  Summary
                </h6>
                <div style={{ height: "30vh" }}>
                  {selBrickToBuy.brickName && (
                    <div className=" w-full d-flex flex-wrap w-100 gap-1 justify-content-evenly align-items-center">
                      <div className="col-4 col-md-4 d-flex  flex-row justify-content-start align-items-center p-2">
                        <p
                          className="text-center mb-0"
                          style={{
                            fontSize: is4kScreen
                              ? "1.6rem"
                              : isXxlScreen
                              ? "0.9rem"
                              : isIpadProPortrait
                              ? "1.5rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "13px",
                            fontWeight: "bold",
                          }}
                        >
                          {selBrickToBuy.brickName} <br />
                          {selBrickToBuy.brickCount} Credits
                        </p>
                      </div>

                      <div className="col-4 col-md-3 d-flex justify-content-center">
                        <button
                          style={{
                            border: "none",
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "2rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : "",
                            paddingLeft: is4kScreen
                              ? "1.5rem"
                              : isXxlScreen
                              ? "0.8rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "",
                            paddingRight: is4kScreen
                              ? "1.5rem"
                              : isXxlScreen
                              ? "0.8rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "",
                          }}
                          onClick={() => handleDecrement(selBrickToBuy)}
                        >
                          -
                        </button>
                        {/* <input
                          style={{ width: "30px", border: "none" }}
                          value={inputData}
                          onChange={(e) => qtyHandleChange(e, selBrickToBuy)}
                        /> */}
                        <div
                          className="border"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingLeft: is4kScreen
                              ? "1rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "10px",
                            paddingRight: is4kScreen
                              ? "1rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "10px",
                            fontSize: is4kScreen
                              ? "1.8rem"
                              : isXxlScreen
                              ? "1rem"
                              : isIpadProPortrait
                              ? "2rem"
                              : isMediumScreen
                              ? "1.1rem"
                              : "",
                          }}
                        >
                          {inputData}
                        </div>
                        <button
                          style={{
                            border: "none",
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.5rem"
                              : isIpadProPortrait
                              ? "2rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : "",
                            paddingLeft: is4kScreen
                              ? "1.5rem"
                              : isXxlScreen
                              ? "0.8rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "",
                            paddingRight: is4kScreen
                              ? "1.5rem"
                              : isXxlScreen
                              ? "0.8rem"
                              : isIpadProPortrait
                              ? "1rem"
                              : "",
                          }}
                          onClick={() => handleIncrement(selBrickToBuy)}
                        >
                          +
                        </button>
                      </div>
                      {buyCreditItems
                        .filter(
                          (summary) =>
                            summary.type.toUpperCase() ===
                            selBrickToBuy.brickName.toUpperCase()
                        ) // Only display relevant type
                        .map((summary) => (
                          <div className="col-2 col-md-3 d-flex flex-column justify-content-center align-items-center">
                            <p
                              key={summary.id}
                              className="w-100 text-center  m-0 p-2"
                              style={{
                                fontSize: is4kScreen
                                  ? "1.8rem"
                                  : isXxlScreen
                                  ? "1.40 rem"
                                  : isIpadProPortrait
                                  ? "2rem"
                                  : isMediumScreen
                                  ? "1.3rem"
                                  : "",
                              }}
                            >
                              ${summary.price.toFixed(2)} USD
                            </p>
                          </div>
                        ))}
                    </div>
                  )}

                  {brickDiscount !== 0 && (
                    <div className="  d-flex flex-row justify-content-between gap-3 p-3">
                      <span
                        className="col-md-8"
                        lang="en"
                        style={{
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                          hyphens: "auto",
                          display: "inline-block",
                          whiteSpace: "pre-wrap",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "2rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "",
                        }}
                      >
                        {brickPromo}
                      </span>
                      <span
                        className="col-md-4 text-center pr-2"
                        style={{
                          color: "red",
                          fontSize: is4kScreen
                            ? "1.8rem"
                            : isXxlScreen
                            ? "1.2rem"
                            : isIpadProPortrait
                            ? "1.9rem"
                            : isMediumScreen
                            ? "1.3rem"
                            : "",
                        }}
                      >
                        -${brickDiscount.toFixed(2)}
                      </span>
                    </div>
                  )}
                </div>
                <hr style={{ border: "1px solid #ddd", width: "100%" }} />
                <p
                  className="item text-center"
                  style={{
                    fontSize: is4kScreen
                      ? "1.9rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : "1rem",
                  }}
                >
                  <span>Estimated Total: </span>
                  <span>${EstimateBrickTotal.toFixed(2)} USD</span>
                </p>
                <div className="d-flex  w-100 justify-content-center align-items-center ">
                  <button
                    disabled={
                      changeCardLoading ||
                      showBrickPromoErrorMsg ||
                      showDiscountError ||
                      (saveAndAddRadio === "savedCard" &&
                        !brickPromo &&
                        allCards.length <= 0) ||
                      (saveAndAddRadio === "addCard" && !cardName) ||
                      (saveAndAddRadio === "addCard" && !cardNumber) ||
                      (saveAndAddRadio === "addCard" && !cardExpirationDetails)
                    }
                    className="col-md-3 topbar-btns  w-auto search-btn"
                    onClick={() => {
                      handleChoosePaymentType();
                    }}
                    style={{ fontSize: is4kScreen ? "1.8rem" : "" }}
                  >
                    Order
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}
